import { OhsActionLink } from 'action/OhsActionModels';
import { OhsAttachment } from 'global-components/form/fields/attachments/OhsAttachmentModels';
import { OhsHRContractorLinkItem } from 'global-components/form/fields/linkHrContractor/OhsHrContractorLinkModels';
import { OhsStatusFilterOption } from 'global-components/register/table/filters/OhsFilterTypes';
import { getCurrentTimezone } from 'global-services/OhsDataParse';
import { ModuleType, OhsModuleCreateBy } from 'global-services/constants/OhsObject';
import { AdminSwitchOptionMap } from 'user/configurations/admin2/OhsAdmin2Config';
import { OhsCurrency } from 'global-components/form/services/OhsFormFieldModels';
import OhsGeoData from 'global-components/form/fields/geoLocation/OhsGeoDataModels';
import { OhsTier } from 'global-services/constants/tier/OhsTier';
import { OhsCusval } from 'global-components/form/cusvals/OhsCusvalModel';

import { OhsTaskType, OhsArchivalDetailsType } from './OhsAssetModels';

class OhsAssetRecord {
  _id: string;

  title?: string;

  businessName?: string;

  allocated: boolean;

  allocationStatus?: OhsStatusFilterOption;

  tzDateCreated: string;

  attachments?: OhsAttachment[];

  allocationActive: boolean;

  dateCreated: string;

  dateIssued: string | null;

  dateExpiry: string | null;

  datePurchased: string | null;

  referenceId: string;

  description: string;

  category: string;

  categoryOther: string | null;

  subcategory: string;

  subcategoryOther: string | null;

  subRows: Array<OhsAssetRecord>;

  task: OhsTaskType | null;

  inherentRiskRating: string | null;

  inherentRiskRatingOther: string | null;

  futureRiskRating: string | null;

  futureRiskRatingOther: string | null;

  currentMitigation: string;

  futureMitigation: string | null;

  residualRisk: string;

  residualRiskOther: string | null;

  futureControl: boolean;

  riskOwner: string;

  riskOwnerOther: string | null;

  riskOwnerLinks: OhsHRContractorLinkItem[];

  cusvals?: OhsCusval[];

  subcategoryCusvals?: OhsCusval[];

  notes?: string;

  previousAttachments?: OhsAttachment[];

  control?: { signatures?: string };

  actionLinks: OhsActionLink[];

  allocationOf: { _id: string; type: ModuleType.Asset } | undefined;

  createdBy: OhsModuleCreateBy;

  signatures?: OhsAttachment[];

  complete: boolean;

  for?: OhsAssetRecord;

  save: boolean;

  reviewNotes: string;

  tzDateSignedoff: string;

  dateCompleted: string;

  dateSignedoff: string;

  signedoffBy: OhsModuleCreateBy;

  confidential?: boolean;

  recurrent: boolean;

  reviewDateRequired: string[];

  archivalDetails?: OhsArchivalDetailsType;

  partialChronology?: OhsAssetRecord[];

  geoData: OhsGeoData | null;

  location: string | null;

  locationOther: string | null;

  serialNumber?: string | null;

  purchaseAmount: OhsCurrency | null;

  status: string | null;

  statusOther: string | null;

  issuedTo: string;

  issuedToOther: string | null;

  issuedToLinks: OhsHRContractorLinkItem[];

  issuedDisplay?: string;

  riskAssessments: OhsAttachment[];

  riskAssessmentsRequired: boolean;

  riskAssessmentsComplete: boolean | null;

  riskRating: string | null;

  riskRatingOther: string | null;

  tier?: any;

  name: string;

  type: ModuleType.Asset;

  previousRiskAssessments?: OhsAttachment[];

  images?: OhsAttachment[];

  previousImages?: OhsAttachment[];

  enableFutureWorkplaceAllocation?: boolean;

  constructor(tier?: OhsTier) {
    this.allocated = false;
    this.tier = tier;
    this.name = '';
    this._id = '';
    this.type = ModuleType.Asset;
    this.title = '';
    this.referenceId = '';
    this.description = '';
    this.category = '';
    this.categoryOther = null;
    this.subcategory = '';
    this.subcategoryOther = null;
    this.subRows = new Array<OhsAssetRecord>();
    this.createdBy = new OhsModuleCreateBy();
    this.tzDateCreated = getCurrentTimezone();
    this.dateCreated = '';
    this.inherentRiskRating = null;
    this.inherentRiskRatingOther = null;
    this.futureRiskRating = null;
    this.futureRiskRatingOther = null;
    this.currentMitigation = '';
    this.futureMitigation = null;
    this.residualRisk = '';
    this.residualRiskOther = null;
    this.futureControl = false;
    this.riskOwner = '';
    this.riskOwnerOther = null;
    this.riskOwnerLinks = new Array<OhsHRContractorLinkItem>();
    this.dateIssued = '';
    this.dateExpiry = null;
    this.task = null;
    this.cusvals = new Array<OhsCusval>();
    this.subcategoryCusvals = new Array<OhsCusval>();
    this.notes = '';
    this.attachments = new Array<OhsAttachment>();
    this.control = { signatures: AdminSwitchOptionMap.disabled };
    this.actionLinks = new Array<OhsActionLink>();
    this.complete = true;
    this.for = undefined;
    this.dateCompleted = '';
    this.dateSignedoff = '';
    this.reviewNotes = '';
    this.signatures = new Array<OhsAttachment>();
    this.signedoffBy = new OhsModuleCreateBy();
    this.title = '';
    this.tzDateSignedoff = '';
    this.save = true;
    this.recurrent = true;
    this.reviewDateRequired = [];
    this.allocationActive = false;
    this.geoData = null;
    this.location = null;
    this.locationOther = null;
    this.serialNumber = null;
    this.datePurchased = null;
    this.purchaseAmount = null;
    this.status = null;
    this.statusOther = null;
    this.issuedTo = '';
    this.issuedToOther = null;
    this.issuedToLinks = new Array<OhsHRContractorLinkItem>();
    this.riskAssessments = new Array<OhsAttachment>();
    this.riskAssessmentsRequired = false;
    this.riskAssessmentsComplete = null;
    this.riskRating = null;
    this.riskRatingOther = null;
    this.images = new Array<OhsAttachment>();
  }
}

export default OhsAssetRecord;
